import { useTranslation } from "react-i18next";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import FilterTextInput from "../FilterTextInput/FilterTextInput";
import FilterMultiSelect from "../FilterMultiSelect/FilterMultiSelect";
import { FilterInput } from "../List/List";
import { FILTER_ACTION_TYPE, FILTER_INPUT_TYPE } from "../../constants";
import "./FilteringSelector.scss";

interface FilteringSelectorProps {
  filterInputs: Array<FilterInput>;
  onFilterChange: Function;
}

export default function FilteringSelector(props: FilteringSelectorProps) {
  const { t } = useTranslation();

  return (
    <Dropdown.Menu className="filtering-selector-component p-3">
      {props.filterInputs.map((filterInput, i) =>
        filterInput.type === FILTER_INPUT_TYPE.MULTI_SELECT &&
        filterInput.options ? (
          <FilterMultiSelect
            key={i}
            label={filterInput.propertyLabel}
            options={filterInput.options}
            value={filterInput.value}
            onChange={filterInput.onChange}
          />
        ) : (
          <FilterTextInput
            key={i}
            propertyName={filterInput.propertyName}
            label={filterInput.propertyLabel}
            placeholder={filterInput.propertyLabel}
            value={filterInput.value}
            onChange={filterInput.onChange}
          />
        )
      )}
      <div className="pt-2">
        <Button
          variant="outline-primary"
          onClick={() => {
            props.onFilterChange(FILTER_ACTION_TYPE.CLEAR);
          }}
        >
          {t("Clear")}
        </Button>
        <Button
          variant="primary"
          className="ms-2"
          onClick={() => {
            props.onFilterChange(FILTER_ACTION_TYPE.APPLY);
          }}
        >
          {t("Apply")}
        </Button>
      </div>
    </Dropdown.Menu>
  );
}
